<div class="breakvalue_container">
  <h1       
    [ngStyle]="
    styleService.getStyleRule([
      tab.configurations?.breakdown?.font,
      undefined,
      'mainText'
    ])
  ">{{ getBreakdownTitle }}</h1>

  <div class="breakvalue_items_container">
    <div class="breakvalue_item" *ngFor="let item of data | keyvalue: valueOrder">
      <div class="breakvalue_amt_section">
        <ng-container *ngFor="let cash of item.value; let i=index">
          <div 
            class="breakvalue_amt"
            [ngStyle]="
              styleService.getStyleRule(
                null, null, [getOutlineStyle?.border]
              )
            " 
          >
            <h1 [ngStyle]="
              styleService.getStyleRule([
                tab.configurations?.breakdown?.font,
                undefined,
                'mainText'
              ])
            ">${{ cash.amt }}</h1>
            <div 
              class="breakvalue_multiplier"           
              [ngStyle]="
                styleService.getStyleRule(
                  null, [getOutlineStyle?.background], null
                )
              " 
              *ngIf="cash.qty > 0">x{{ cash.qty }}</div>
          </div>
          <div class="breakvalue_line" *ngIf="i < numGroups(item.value)">+</div>
        </ng-container>
        <h2 [ngStyle]="
          styleService.getStyleRule([
            tab.configurations?.breakdown?.font,
            undefined,
            'mainText'
          ])
        ">=</h2>
        <div class="breakvalue_total">
          <h1 [ngStyle]="
            styleService.getStyleRule([
              tab.configurations?.breakdown?.font,
              undefined,
              'mainText'
            ])
          ">${{ calculateCost(item.value) }}</h1>
        </div>
      </div>
      <div class="breakvalue_btn_section">
        <button 
          [disabled]="optionSelected"
          class="breakvalue_btn"  
          (click)="selectItem(item.value)"
          [ngStyle]="
            styleService.getStyleRule(
              [getSelectButtonStyle?.text],
              [getSelectButtonStyle?.background],
              [getSelectButtonStyle?.border]
            )
          "
        >Select</button>
      </div>
    </div>
  </div>

  <button 
    class="breakvalue_btn breakvalue_back"
    [disabled]="optionSelected"
    (click)="exitBreakValue()"
    [ngStyle]="
      styleService.getStyleRule(
        [getBackButtonStyle?.text],
        [getBackButtonStyle?.background],
        [getBackButtonStyle?.border]
      )
    "
  >Go Back</button>
</div>